import { render, staticRenderFns } from "./CardDesignArea.vue?vue&type=template&id=24aef1e4&"
import script from "./CardDesignArea.vue?vue&type=script&lang=js&"
export * from "./CardDesignArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports